import { useEffect } from 'react';
import Sidebar from '../components/Sidebar.jsx';

const Beetroot = (props) => {

    let Fig1 = "https://static.igem.wiki/teams/5066/hardware/figure-1-comparison-between-male-and-female-antenna.png"
	let Fig2 = "https://static.igem.wiki/teams/5066/hardware/peeling-cutting-and-testing.png"
	let Fig3 = "https://static.igem.wiki/teams/5066/hardware/beetroot-peel-before-drying.png"
	let Fig4 = "https://static.igem.wiki/teams/5066/hardware/example-of-oviposition.png"
	let Fig5 = "https://static.igem.wiki/teams/5066/hardware/hay-water.png"
	let Fig6 = "https://static.igem.wiki/teams/5066/hardware/concentration-dependent.png"
	let Fig7 = "https://static.igem.wiki/teams/5066/hardware/concentration-dependent-assays-with-a-higher-concentration.png"
	let Fig8 = "https://static.igem.wiki/teams/5066/hardware/comparison-of-water.png"
	let Fig9 = "https://static.igem.wiki/teams/5066/hardware/comparison-of-water-control-hay-infusion-water-positive-control.png"
	let Fig10 = "https://static.igem.wiki/teams/5066/hardware/experiment-design-to-compare-water.png"
	let Fig11 = "https://static.igem.wiki/teams/5066/hardware/colouration-of-water.png"
	let Fig12 = "https://static.igem.wiki/teams/5066/hardware/oviposition-assay.png"
	let Fig13 = "https://static.igem.wiki/teams/5066/hardware/oviposition-assay-results.png"
	let Fig14 = "https://static.igem.wiki/teams/5066/hardware/transforming-beetroot-peel-powder.png"

    let sections = [
        { id: 's1', name: 'Background' },
        { id: 's2', name: 'Production of Our Own Beetroot Peels' },
		{ id: 's3', name: 'Functional Assays' },
        { id: 's4', name: 'Conclusion' },
        { id: 's5', name: 'References' },
		
    ];

    useEffect( () => {
        if (props.to) {
            if (props.to !== 'none') {
                document.getElementById(props.to).scrollIntoView({behavior: 'smooth'});
            }
        }
    });

    return (
        <div>

            <div className='flex'>

                <Sidebar sections={sections} />

                {/* Main Content */}
                <div className='flex-col w-4/5 lg:p-[50px] p-[5px] my-[10px] space-y-16 rounded-2xl bg-white shadow-[-2px_4px_8px_-2px_rgba(0,0,0,0.2)]'>

                    <div className='pb-12'>
                        <section id='s1' className='pb-12'>
                            <h2 className='text-2xl md:text-3xl font-bold text-[#C94C67] leading-relaxed'>
							Abstract
                            </h2>
							<p className='mt-2 text-gray-700 leading-relaxed'>
							Present practices of arthropod attraction make use of a bicyclic alcohol called geosmin. Its pure form is expensive and challenging to use widely. Thus, we researched and determined a cheaper alternative. With data from functional assays, our processed beetroot peel proved to be capable of replacing geosmin with its effectiveness.
                            </p>
							<h2 className='text-2xl mt-10 md:text-3xl font-bold text-[#C94C67] leading-relaxed'>
							Background
                            </h2>
                            <p className=' text-xl font-bold mt-8 text-[#CF3769]'>
							Mosquito Olfactory
                            </p>
                            <p className='mt-2 text-gray-700 leading-relaxed'>
								Mosquitoes are vectors for many diseases, transmitting them through the bites of female mosquitoes. To be effective as disease vectors, they rely on external and internal factors to mediate their behavior in mating, blood-feeding, and ovipositing. One of the essential external factors utilized by mosquitoes is their olfactory. So, how does their olfactory work?
                            </p>
                            <p className='mt-5 text-gray-700 leading-relaxed'>
							In adult mosquitoes, olfactory receptors are localized to peripheral olfactory organs, such as the antennae, maxillary palps, and proboscis in mosquitoes. The peripheral olfactory organs have sensilla located on them. On the sensillum, there are 3 main classes of olfactory receptors: gustatory receptors (GRs), ionotropic receptors (IRs), and odorant receptors (ORs), and each of them serves a different function. IRs and ORs detect a wide range of odorants, whereas GRs are only sensitive to CO2 and other volatile odorants. The signals from the receptors are then sent through the olfactory receptor neurons. (McMeniman, 2016)
                            </p>
							<p className='mt-5 text-gray-700 leading-relaxed'>
							In certain mosquito species, the morphology of the antennae and maxillary have developed to display sexual dimorphism. Male <span className='italic'> Aedes </span> present a large bushy antennae whilst females have a more slender and hairless antennae. This difference is likely due to demands for both hearing and olfaction. (Li et al., 2022)        
							</p>
                            
                            <img
                                src={Fig1}
                                alt=''
                                className='mt-5 w-full md:w-100 h-auto rounded-lg shadow-lg'
                            />
							<p className='mt-2 text-sm text-gray-700 leading-relaxed'>
							Figure 1: Comparison between male and female antenna 
							</p>
							<p className=' text-xl font-bold mt-8 text-[#CF3769]'>
							Vector Control Methods Rely on Control/Manipulation
                            </p>
							<p className='mt-2 text-gray-700 leading-relaxed'>
							Insects use infochemicals from their environment at all stages of their life including oviposition. When searching for potential oviposition sites, mosquitoes are guided by infochemicals such as pheromones to find and determine whether or not they are suitable breeding sites (Mwingira et al., 2020).
							</p>
							<p className='mt-2 text-gray-700 leading-relaxed'>
							As shown in the gonotrophic cycle of mosquitoes, they stop host-seeking when they have ingested a blood meal, and they start searching for oviposition sites. Host-seeking behavior can only be restored a day after oviposition. During their search for oviposition sites, a functional class of trichoid sensilla is activated, and certain infochemicals are appealing to this sensillum (Mwingira et al., 2020). It should be noted that certain infochemicals only appeal to certain species of mosquitoes. Our team decided to use Geosmin because it can be found in beetroot peels and has been proven to be just as effective. Moreover, we can support local businesses through our purchases as it is a local vegetable in Taiwan (Melo et al., 2020).
							</p>
							<p className=' text-xl font-bold mt-8 text-[#CF3769]'>
							Why Beetroot Peel?
                            </p>
							<p className='mt-2 text-gray-700 leading-relaxed'>
							Beetroot peel has shown potential in attracting <span className='italic'>  Aedes </span> mosquitoes, the primary vectors of dengue fever. Geosmin, the volatile organic compound released by beetroot peels, mimics the natural chemical cues that are used by mosquitoes to locate oviposition sites (Melo et al., 2020). We decided to use beetroot peel instead of chemically synthesized geosmin as chemically induced geosmin is extremely expensive and difficult to access locally. Our solution is a <span className='font-bold'> cheaper alternative </span> that works just as well and can also be <span className='font-bold'> sourced locally </span>. In our project, we utilized beetroot peel as bait in our sticky ovitrap, which is a device designed to capture mosquitoes during their oviposition phase in order to reduce local vectors.
							</p>
							<p className='mt-2 text-gray-700 leading-relaxed'>
							Other familiar sources of practical mosquito attractants are light, sugar, hay water, and much more. Light specifically attracts day-biting mosquitoes, such as our dengue fever-transmitting <span className='italic'>  Aedes </span> mosquitoes. Some hypotheses surrounding this include light as a waypoint for food sources or reactions surrounding the circadian rhythm (Says, 2020). Meanwhile, sugar is straightforward as it is a crucial food source for many mosquito species and acts as common bait. Finally, hay water takes advantage of the fermentation of organic compounds, producing carbon dioxide mimicking the expiration of living organisms, or from a mosquito’s point of view, blood sources.
							</p>
							<p className='mt-2 text-gray-700 leading-relaxed'>
							However, many of these attractants have their drawbacks. Light requires constant power and is not all-encompassing. Many species that bite at night are photophobic, and some are only attracted to specific wavelengths of light. Light is known for drawing in many other non-target species too. The attraction towards non-target species is the same for sugar as it is also the diet of many vital organisms, like bees, which are endangered in many areas and cannot risk further population decline. In urban areas, sugar solutions are also difficult to leave unattended for long times in stationary water bodies, like in an ovitrap as it could attract ants, which could be disruptive to the surrounding area. Hay water, on the other hand, requires fresh preparation as this attractant is based on the gasses produced during fermentation rather than a compound, such as geosmin, being present. Out of these, we found hay water most commonly used and the most competitive in terms of practicality for sticky ovitraps, so we decided to include hay water as a test against our beetroot peel solution in our functional assays.
							</p>
							</section>
					
							<div className='pb-12'>
                    
					<section id='s2' className='pb-12'>
                            <h2 className='text-2xl md:text-3xl font-bold text-[#C94C67] leading-relaxed'>
							Production of Our Own Beetroot Peels
                            </h2>
							<p className=' text-xl font-bold mt-8 text-[#CF3769]'>
							Beetroot Peel Processing
                            </p>
							<p className='mt-2 text-gray-700 leading-relaxed'>
							To produce beetroot peel powder, we first bought around 18 kg of beetroot. Using peelers, we peeled all of the beetroots and preserved the peel for the powder. We laid out our beetroot peels on aluminum foil and placed them in the oven for 20 minutes at 170 degrees Celsius, thus dehydrating the beetroot peels and making them easy to grind into powder.
							</p>
							<img
                                src={Fig2}
                                alt=''
                                className='mt-5 w-full md:w-100 h-auto rounded-lg shadow-lg'
                            />
							<p className='mt-2 text-sm text-gray-700 leading-relaxed'>
							Figure 2: Peeling, cutting, and testing different methods to achieve the best conditions for dry beetroot peel 
							</p>
							<p className='mt-5 text-gray-700 leading-relaxed'>
							Then, we used the mortar and pestle to grind the beetroot peels into powder, allowing the final product to be able to dissolve into the water. The beetroot peel-infused water would serve as an attractive element in our sticky ovitrap. In addition, the final grounded powder is then sifted through a sift to remove larger pieces, leaving a final product of only the fine powder. The fine powder benefits the packaging of our final product as it is convenient for consumers to use.
							</p>
							<img
                                src={Fig3}
                                alt=''
                                className='mt-5 w-full md:w-100 h-auto rounded-lg shadow-lg'
                            />
							<p className='mt-2 text-sm text-gray-700 leading-relaxed'>
							Figure 3: Beetroot peel before drying and powdered for oviposition assay
							</p>
							<p className='mt-5 text-gray-700 leading-relaxed'>
							The above processes were the result of our testing. There are no standardized methods to process beetroot peel, so we opted to find the optimal conditions on our own. 
							</p>
							<p className='mt-2 text-gray-700 leading-relaxed'>
							We did some prior research on beetroot chip recipes to gain a rough idea of the potential process, from which we based our preliminary trials. From the preliminary trial results, we designed a plausible method for our final production of beetroot peel powder. Once the ideal conditions were settled, we implemented the method to mass-produce our beetroot peel powder. 
							</p>
							<a
                                    href="https://static.igem.wiki/teams/5066/hardware/beetroot-drying-lab-notebook-google-docs.pdf"
                                    rel="noopener noreferrer"
                                    className=" font-bold text-[#d77d91] hover:underline hover:text-[#C94C67] transition-colors duration-200"
                                >
							View our entire process here: Beetroot drying lab notebook (PDF)
							</a>
						</section>
					</div>
						<section id='s3' className='pb-12'>
                            <h2 className='text-2xl md:text-3xl font-bold text-[#C94C67] leading-relaxed'>
Functional Assays                            
							</h2>
							<p className=' text-xl font-bold mt-8 text-[#CF3769]'>
							Testing optimal concentration
                            </p>
							<p className='mt-2 text-gray-700 leading-relaxed'>
							We conducted several oviposition assays to determine the attractiveness of our beetroot peel powders. Oviposition assay is an experiment designed to evaluate the preference of blood-fed mosquitoes on different oviposition substrates (Khan et al., 2023). We can count the number of oviposited eggs on the filter papers to elucidate the mosquitoes’ innate preference toward different solutions. A higher oviposited egg count is interpreted as a higher preference displayed by mosquitoes. An example of the oviposition assay is shown in Figure 4.
							</p>
							<img
                                src={Fig4}
                                alt=''
                                className='mt-5 w-full md:w-96 h-auto rounded-lg shadow-lg'
                            />
							<p className='mt-2 text-sm text-gray-700 leading-relaxed'>
							Figure 4: Example of oviposition assay in a cage with different solutions
							</p>
							<p className='mt-2 text-gray-700 leading-relaxed'>
							In order to find the optimal concentration of beetroot peel to attract mosquitoes, we placed different concentrations of beetroot peel powder-infused water in a cage with 10 blood-fed <span className='italic'> Aedes albopictus </span> mosquitoes (NTU CPH lab strain) to conduct an oviposition assay. The control groups used in the experiment were water and hay infusion water. Hay infusion water is a common oviposition medium used in attracting mosquitoes in the ovitrap over water. 
							</p>
							<p className='mt-10 font-bold text-gray-700 leading-relaxed'>
							The positions of our trial are as follows:
							</p>
							<img
                                src={Fig5}
                                alt=''
                                className='mt-5 w-full md:w-100 h-auto rounded-lg shadow-lg'
                            />
							<p className='mt-5 text-gray-700 leading-relaxed'>
							We rotated the concentrations of beetroot peel infusion water, or hay water and water to ensure the oviposition preference demonstrated by the female mosquitoes is due to the choice of the solutions not the physical position.
							</p>
							<p className=' text-xl font-bold mt-8 text-[#CF3769]'>
								Trial 1
                            </p>
							<p className='mt-2 text-gray-700 leading-relaxed'>
							We put in a total of 4 concentrations of beetroot peel water: 2.5 mg/ml, 1.0 mg/ml, 0.5 mg/ml, 0.1 mg/ml, and ddH20 water as our control, and did three replicates with each concentration in a different position each trial. Each cup contained 60 ml of solution and was lined with tissue paper as oviposition sites, and each cage held 10 mosquitoes. We waited for 4 days to allow the mosquitoes to lay eggs until we collected the filter papers to count the oviposited eggs. Two different students counted the same filter paper so that the data we collected was as consistent and accurate as possible.
							</p>
							<img
                                src={Fig6}
                                alt=''
                                className='mt-5 w-full md:w-96 h-auto rounded-lg shadow-lg'
                            />
							<p className='mt-2 text-sm text-gray-700 leading-relaxed'>
							Figure 5: Concentration-dependent assay of different beetroot peel in relation to the number of oviposited eggs
							</p>
							<p className='mt-5 text-gray-700 leading-relaxed'>
							As seen in the table and graph, the beetroot peel solution of 2.5 mg/ml had the most eggs laid, displaying a significant difference compared to a lower concentration of beetroot peel infusion water and control groups. However, upon analyzing the oviposition data, we also noticed a consistent trend where fewer eggs are laid when the solution is placed in the middle of the cage, regardless of the type of solution. We suspected that mosquitoes may prefer to lay eggs at the corners of the cage than in the middle of the cage.
							</p>
							<p className=' text-xl font-bold mt-8 text-[#CF3769]'>
								Trial 2
                            </p>
							<p className='mt-2 text-gray-700 leading-relaxed'>
							To minimize biased and skewed preferences towards our beetroot peel infusion water, we decided to conduct another trial with higher concentrations of beetroot peel powder. We also will remove the solution in the middle of the cage to ensure fair selection choice among the mosquitos. In the first trial, the highest oviposition preference was 2.5 mg/ml, and this concentration was the lowest concentration in this second experiment. Hence, we would like to ask whether higher preference will be observed if we would use higher concentrations of beetroot peel powder.
							</p>
							<img
                                src={Fig7}
                                alt=''
                                className='mt-5 w-full md:w-96 h-auto rounded-lg shadow-lg'
                            />
							<p className='mt-2 text-sm text-gray-700 leading-relaxed'>
							Figure 6: A set of concentration-dependent assays with a higher concentration of beetroot peel infusion water
							</p>
							<p className='mt-5 text-gray-700 leading-relaxed'>
							Our experiment was conducted in triplicates to compare whether higher concentrations of beetroot peel powder would result in a higher oviposition preference. Our results showed that there was no significant difference among the different concentrations, even with a series of higher concentrations of beetroot peel powder being used (2.5 mg/ml, 3.0 mg/ml, 4.0 mg/ml, and 5.0 mg/ml). This experiment clearly indicated that using higher concentrations of beetroot peel infusion powder exhibited similar attraction toward mosquitoes. Hence, we concluded that 2.5 mg/ml is the optimum concentration as an oviposition attractant. 
							</p>
							<p className=' text-xl font-bold mt-8 text-[#CF3769]'>
								Trial 3
                            </p>
							<p className='mt-2 text-gray-700 leading-relaxed'>
							At the same time, we did assays to compare the eggs laid in hay infusion water versus water only. The purpose of this experiment is to determine the preference of the mosquitoes toward conventional oviposition substrates that are commonly used in field trials and oviposition assay. 
							</p>
							<img
                                src={Fig8}
                                alt=''
                                className='mt-5 w-full md:w-96 h-auto rounded-lg shadow-lg'
                            />
							<p className='mt-2 text-sm text-gray-700 leading-relaxed'>
							Figure 7: Comparison of water (control)’s  and hay infusion water (positive control) ‘s amount of eggs laid
							</p>
							<p className='mt-5 text-gray-700 leading-relaxed'>
							Mosquitos did not show a specific preference for any of the concentrations of hay infusion water. There is no significant difference between the control and different concentrations of hay infusion water. Since the data showed that the original concentration of hay water used recorded the highest oviposition preference as compared to other diluted solutions, we will be using this concentration for further assays.
							</p>
							<p className='mt-2 text-gray-700 leading-relaxed'>
							We then compared the results of trials 2 and 3 and decided to conduct another trial to compare the oviposition preference for control,  2.5 mg/ml of beetroot peel infusion water with original hay infusion water. 
							</p>
							<p className=' text-xl font-bold mt-8 text-[#CF3769]'>
							Proof of concept
                            </p>
							<p className=' text-l font-bold mt-8 text-black'>
							Assay 1
                            </p>
							<p className='mt-2 text-gray-700 leading-relaxed'>
							After conducting separate concentration-dependent assays with beetroot peel infusion water and hay infusion water, we would now compare both of these substrates. We then conducted an oviposition assay with 2.5 mg/ml of beetroot peel, water, and original hay water in one cage. This assay was conducted in triplicates. 
							</p>
							<img
                                src={Fig9}
                                alt=''
                                className='mt-5 w-full md:w-100 h-auto rounded-lg shadow-lg'
                            />
							<p className='mt-2 text-sm text-gray-700 leading-relaxed'>
							Figure 8: Comparison of water (control), hay infusion water (positive control), and beetroot peel infusion water at 2.5 mg/ml (treatment group)
							</p>
							<img
                                src={Fig10}
                                alt=''
                                className='mt-5 w-full md:w-96 h-auto rounded-lg shadow-lg'
                            />
							<p className='mt-2 text-sm text-gray-700 leading-relaxed'>
							Figure 9: Experiment design to compare water, hay infusion water, and beetroot peel water
							</p>
							<p className='mt-2 text-gray-700 leading-relaxed'>
							In this experiment, our results indicated that <span className='italic'> Aedes albopictus </span> mosquitoes highly significantly preferred beetroot peel infusion water (2.5 mg/ml) to hay infusion water. However, we suspected that the results might be skewed towards beetroot peel water due to the coloration that is displayed in the cage as shown in Figure 10. 
							</p>
							<img
                                src={Fig11}
                                alt=''
                                className='mt-5 w-full md:w-96 h-auto rounded-lg shadow-lg'
                            />
							<p className='mt-2 text-sm text-gray-700 leading-relaxed'>
							Figure 10: Colouration of water, hay infusion water, and beetroot peel water (from top to bottom)
							</p>
							<p className=' text-l font-bold mt-8 text-black'>
							Assay 2
                            </p>
							<p className='mt-2 text-gray-700 leading-relaxed'>
							Hence, we started another round of experiments to rule out the coloration factor. This time, we covered each solution with black paper to provide a fair choice for the mosquitoes so that the selection of oviposition sites is based on odorant factors only.
							</p>
							<img
                                src={Fig12}
                                alt=''
                                className='mt-5 w-full md:w-96 h-auto rounded-lg shadow-lg'
                            />
							<p className='mt-2 text-sm text-gray-700 leading-relaxed'>
							Figure 11: Oviposition assay to compare water, hay infusion water, and beetroot peel water with black color paper to rule out the influence of coloration on the oviposition behavior of mosquitoes
							</p>
							<img
                                src={Fig13}
                                alt=''
                                className='mt-5 w-full md:w-96 h-auto rounded-lg shadow-lg'
                            />
							<p className='mt-2 text-sm text-gray-700 leading-relaxed'>
							Figure 12: Oviposition assay results with black paper to rule out the coloration factor in the oviposition behavior of mosquitoes. Female mosquitoes of Ae. albopictus consistently preferred beetroot peel infusion water over hay infusion water and water only. 
							</p>
							<p className='mt-5 text-gray-700 leading-relaxed'>
							The results obtained from this experiment were highly significant, with the p-value equal to 0.0003. This experiment demonstrated that the preference of the mosquitoes toward the beetroot peel infusion water group was only based on the odorant factor.
							</p>
							<p className='mt-2 font-bold text-gray-700 leading-relaxed'>
							Our research findings confirm that beetroot peel is an excellent choice of oviposition attractant. 
							</p>
							</section>
							
							<section id='s4' className='pb-12'>
							<h2 className='text-2xl mt-10 md:text-3xl font-bold text-[#C94C67] leading-relaxed'>
							Conclusion
                            </h2>
							<p className='mt-8 text-gray-700 leading-relaxed'>
							Negating the possible interferences of color and location bias, we successfully tested and proved the repeated success of our beetroot peel solution against hay water and ddH2O. Therefore, beetroot peel can be used as a great alternative to attract <span className='italic'>Aedes </span> mosquitoes.
							</p>
							<img
                                src={Fig14}
                                alt=''
                                className='mt-5 w-full md:w-100 h-auto rounded-lg shadow-lg'
                            />
							<p className='mt-2 text-sm text-gray-700 leading-relaxed'>
							Figure 13. Transforming beetroot peel powder into a marketable product as an oviposition attractant, Mozzie Beeter capsules
							</p>
							<p className='mt-5 text-gray-700 leading-relaxed'>
							The consistent and promising results obtained from this experiment greatly motivated us. We have integrated our findings from this experiment with our <span className='font-bold'> recombinant biolarvicides </span> and <span className='font-bold'> sticky ovitrap</span>. We also further developed the beetroot powder into capsules and plan to market them as Mozzie Beeter capsules.
							</p>
							</section>

							<section id='s5' className='pb-12'>
							<h2 className='text-2xl mt-10 md:text-3xl font-bold text-[#C94C67] leading-relaxed'>
							References
                            </h2>
							<p className='mt-5 text-gray-700 leading-relaxed'>
                            McMeniman, C. J. (2016, January 1). Chapter 11 - Disruption of Mosquito Olfaction (Z. N. Adelman, Ed.). ScienceDirect; Academic Press.
                            </p>
                            <p className='mt-1 text-gray-700 leading-relaxed'>
                                <a href='https://www.sciencedirect.com/science/article/abs/pii/B9780128002469000119'>
									https://www.sciencedirect.com/science/article/abs/pii/B9780128002469000119
                                </a>
                            </p>
							<p className='mt-5 text-gray-700 leading-relaxed'>
							Li, J., Merchant, A., Zhou, S., Wang, T., Zhou, X., & Zhou, C. (2022). Neuroanatomical basis of sexual dimorphism in the mosquito brain. IScience, 25(11), 105255.<span> </span>
							<span>
							<a href='https://doi.org/10.1016/j.isci.2022.105255'>
									https://doi.org/10.1016/j.isci.2022.105255
                                </a>
							</span>
							</p>
	
							<p className='mt-5 text-gray-700 leading-relaxed'>
							Mwingira, V., Mboera, L. E. G., Dicke, M., & Takken, W. (2020). Exploiting the chemical ecology of mosquito oviposition behavior in mosquito surveillance and control: a review. Journal of Vector Ecology, 45(2), 155–179.
							<span> </span>
							<a href='https://doi.org/10.1111/jvec.12387'>
								https://doi.org/10.1111/jvec.12387
                                </a>
							</p>

							<p className='mt-5 text-gray-700 leading-relaxed'>
							Melo, N., Wolff, G. H., Arribas, R., Costa-da-Silva , A. L., Triana, M. F., Gugger, M., Riffell, J. A., DeGennaro, M., & Stensmyr, M. C. (2020). Geosmin Attracts Aedes aegypti Mosquitoes to Oviposition Sites. Current Biology, 30(1), 127-134.e5.
							<span> </span>
							<a href='https://doi.org/10.1016/j.cub.2019.11.002'>
							https://doi.org/10.1016/j.cub.2019.11.002
                                </a>
							</p>

							<p className='mt-5 text-gray-700 leading-relaxed'>
							Says, B. G. (2020, July 28). Study: Mosquitoes species are attracted and repelled by light at different times of day. News-Medical.net.
							<span> </span>
							<a href='https://www.news-medical.net/news/20200728/Study-Mosquitoes-species-are-attracted-and-repelled-by-light-at-different-times-of-day.aspx'>
							https://www.news-medical.net/news/20200728/Study-Mosquitoes-species-are-attracted-and-repelled-by-light-at-different-times-of-day.aspx
                                </a>
							</p>

							<p className='mt-5 text-gray-700 leading-relaxed'>
								Khan, Z., Bohman, B., Ignell, R., & Hill, S. R. (2023). Odour-mediated oviposition site selection in Aedes aegypti depends on aquatic stage and density. Parasites & Vectors, 16(1), 264.
							<span> </span>
							<a href='https://parasitesandvectors.biomedcentral.com/articles/10.1186/s13071-023-05867-1'>
							https://parasitesandvectors.biomedcentral.com/articles/10.1186/s13071-023-05867-1
                                </a>
							</p>
                           

							
						
						</section>
                 
								</div>
							</div>
						</div>
					</div>
    );
};

export default Beetroot;
